/**
 * InversifyJS need to use the type as identifiers at runtime.
 * We use symbols as identifiers but you can also use classes and or string literals.
 */
export var FirestoreClientTypes = {
    GraphService: Symbol('GraphService')
};



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/firestoreClientTypes.ts
// module id = 318
// module chunks = 50